export default "__VITE_PUBLIC_ASSET__3f7b6d87__"